import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import localeData from 'dayjs/plugin/localeData';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import weekday from 'dayjs/plugin/weekday';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';
import type { Locale } from 'zf-web-components';
import type { LocalStore } from 'zf-web-infra';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/zh-tw';
import 'dayjs/locale/en';
import 'dayjs/locale/ja';

class DayjsService {

  private readonly dayjsLocaleMap: { [key: string]: string } = {
    zh_cn: 'zh-cn',
    zh_hk: 'zh-hk',
    jp: 'ja',
    en: 'en'
  };

  init(local: LocalStore): void {
    const lang = this.lang(local);
    dayjs.locale(this.dayjsLocaleMap[lang]);
    dayjs.extend(weekday);
    dayjs.extend(localeData);
    dayjs.extend(utc);
    dayjs.extend(timezone);
    dayjs.extend(customParseFormat);
    dayjs.extend(duration);
    dayjs.extend(quarterOfYear);
    dayjs.extend(weekOfYear);
    dayjs.extend(advancedFormat);
    dayjs.extend(weekYear);
  }

  private lang(local: LocalStore): Locale {
    return local.lang as Locale ?? 'zh_cn';
  }

}

export const day = new DayjsService();
